<template>
  <div id="app" :class="site">
      <div :class="{'behind-modal': modalOpen}">
          <Header></Header>
          <Nav></Nav>
          <MobileHeader></MobileHeader>
          <main>
              <router-view @openHelpModal="showHelpModal"/> 
          </main>
          <Footer></Footer>
      </div>
        
      <Modal v-if="!hasCookie">
          <div class="card-bg">
              <h2>{{ $t(`home_page.${siteName}.statement_title`) }}</h2>
              <p>{{ $t(`home_page.${siteName}.statement_text`) }}</p>
              <button @click="dismissDisclaimer">{{ $t(`home_page.${siteName}.statement_button_text`) }}</button>
          </div>
      </Modal>

      <Modal v-if="showHelp">
          <div class="card-bg">
              <button @click="closeHelpModal">
                  <span class="sr-only">{{ $t('labels.close_help') }}</span>
                  <span class="close-icon" aria-hidden="true"></span>
              </button>
              <h2>{{ $t('help_modal.title') }}</h2>
              <div v-for="(q,i) in helpContent" :key="i" class="question">
                <h3 class="h4">{{ q.q }}</h3>
                <p>{{ q.a }}</p>
              </div>
              <div>
                <h3 class="h4">{{ $t(`help_modal.feedback.${site}.q`) }}</h3>
                <p v-html="$t(`help_modal.feedback.${site}.a`)"></p>
              </div>
          </div>
      </Modal>

      <Modal v-if="showSavedListMsg">
          <div class="card-bg">
             <button @click="closeSavedModal">
                  <span class="sr-only">{{ $t('labels.close_help') }}</span>
                  <span class="close-icon" aria-hidden="true"></span>
              </button>
              <h2>{{ savedMsg }}</h2>
              <button @click="closeSavedModal">{{ $t(`home_page.${siteName}.statement_button_text`) }}</button>
          </div>
      </Modal>
      
      <JsonLD :data="json_ld"></JsonLD>

  </div>
</template>

<script>
import Nav from '@/components/Nav';
import Header from '@/components/Header';
import MobileHeader from '@/components/MobileHeader';
import Footer from '@/components/Footer';
import Modal from '@/components/Modal'
import JsonLD from '@/components/JsonLD'


import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
      Nav,
      Header,
      MobileHeader,
      Footer,
      Modal,
      JsonLD
  },
  head () {
    return {
      link:[
          { rel: 'icon', href: require(`./assets/images/${this.site}-favicon.png`), sizes: '16x16', type: 'image/png' }, 
      ]
    }
  },
  data: function () {
      return {
          hasCookie: false,
          showHelp: false
      }
  },
  computed: {
      ...mapGetters({
          'site': 'search/site',
          'showSavedListMsg': 'list/show_modal',
          'savedMsg': 'list/modal_msg',
      }),
      modalOpen () {
        return !this.hasCookie || this.showHelp;
      },
      helpContent () {
        return this.$i18n.messages[this.$i18n.locale].help_modal.questions;
      },
      siteName () {
        return this.site || 'cmh';
      },
      json_ld () {
        let site_content = this.$i18n.messages[this.$i18n.locale].main[this.site]
        return {
            "@context": "http://schema.org",
            "accessibilityAPI": "ARIA",
            "accessibilityFeature": [
                "resizeText/CSSEnabled",
                "displayTransformability",
                "alternativeText"
            ],
            "accessibilityHazard": [
                "noFlashingHazard",
                "noMotionSimulationHazard",
                "noSoundHazard"
            ],
            "accessibilityControl": [
                "fullKeyboardControl",
                "fullMouseControl"
            ],
            "publisher": {
                "@type": "Organization",
                "name": site_content.museum_name
            }
        }
      }
  },
  methods: {
      dismissDisclaimer() {
          this.$cookies.set("advisory-dismissed",true, Infinity);
          this.hasCookie = true;
      },
      showHelpModal () {
        this.showHelp = true;
      },
      closeHelpModal () {
        this.showHelp = false;
      },
      closeSavedModal () {
        this.$store.dispatch('list/showModal', {display: false})
      },
  }, 
  async created() {
    if (this.$cookies.get("advisory-dismissed")) {
        this.hasCookie = true;
    }
  
    this.$store.dispatch('search/site', {site: location.hostname}).then(() => {
        this.$store.dispatch('list/saved_ids');
        this.$emit('updateHead')
        let langMap = {
          'en': 'en-US',
          'fr': 'fr-FR'
        }
        document.querySelector('html').setAttribute('lang', langMap[this.$i18n.locale]);
    });
  
    // remove Flask generated json_ld if app is mounted
    let serveJson = document.querySelector('#served-json')
    if (serveJson) serveJson.remove();
  }
}
</script>

<style scoped lang="scss">
  .behind-modal {
    position: fixed;
  }
  .close-icon {
    display: block;
    cursor: pointer;

    &:after {
          content: '';
          background-image: url('./assets/images/icon-close-x.svg');
          background-size: contain;
          display: block;
          height: 20px;
          width: 20px;
          position: relative;
      }
  }
  .card-bg {
    /deep/ a {
      color: $dark-gray1;
    }
  }
</style>